import { Switch } from "react-router-dom";
import ParceirosListaPage from "./Listagem/index";
import ParceirosDetalhesPage from "./Detalhes/index";
import AuthRoute from "ui/components/AuthRoute";
import { PermissaoEnum } from "core/resources/enums/permissao";

function ParceirosPages() {
  return (
    <Switch>
      <AuthRoute
        exact
        path="/administracao/parceiros"
        component={ParceirosListaPage}
        permissions={[PermissaoEnum.Backoffice.Admin.Parceiro.Visualizar]}
      />
      <AuthRoute
        path="/administracao/parceiros/criar"
        component={ParceirosDetalhesPage}
        permissions={[PermissaoEnum.Backoffice.Admin.Parceiro.Criar]}
        exact
      />

      <AuthRoute
        path="/administracao/parceiros/:id"
        component={ParceirosDetalhesPage}
        permissions={[PermissaoEnum.Backoffice.Admin.Parceiro.Editar]}
      />
    </Switch>
  );
}

export default ParceirosPages;
